module.exports = __webpack_public_path__ + "static/media/TUNE_6221.6bab1bdd.jpg";